import { REACT_APP_STORAGE_URL } from "../config";

export const getFullAssetPath = (asset: string): string => {
  return `${REACT_APP_STORAGE_URL}/assets/${asset.replace(/^\/+/i, "")}`;
};
